




































































































































































import Vue from 'vue'
import { mapState } from 'vuex'
import Title from '~/components/car/classifieds/view/partials/Header/Title.vue'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'
import Price from '~/components/car/classifieds/view/partials/Price/Price.vue'

export default Vue.extend({
  components: {
    CShimmer,
    Title,
    CClassifiedFavoriteButton,
    Price
  },
  computed: {
    ...mapState({
      refs: state => state.classifieds.view.refs
    }),
    parkingRefExists() {
      const { isParked } = this.refs
      return isParked !== null && typeof isParked !== 'undefined'
    },
    randomWidth() {
      return Math.floor(Math.random() * 40) + 40
    }
  }
})
